"use client";
import { decodeJwtToken } from "@climatepartner/utils";
export function navigateTo(address) {
    window.location.href = address;
}
export const hasValidToken = (token, expiration) => !!(token && expiration && expiration > Date.now());
export const getCodeStateQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    const codeParam = params.get("code") ?? "";
    const stateParam = params.get("state") ?? "";
    const realmParam = params.get("realm") ?? "";
    return { codeParam, stateParam, realmParam };
};
export function clearUrlFromKeycloakState(urlString) {
    const url = new URL(urlString);
    url.searchParams.delete("realm");
    url.searchParams.delete("code");
    url.searchParams.delete("state");
    url.searchParams.delete("session_state");
    // Empty hash is breaking Keycloak redirect_uri check
    if (url.toString().endsWith("#")) {
        url.hash = "";
    }
    return url.toString();
}
export function getUserFromAccessToken(accessToken) {
    const decodedAccessToken = decodeJwtToken(accessToken);
    if (decodedAccessToken) {
        return {
            id: decodedAccessToken.sub,
            name: decodedAccessToken.name,
            givenName: decodedAccessToken.given_name,
            familyName: decodedAccessToken.family_name,
            email: decodedAccessToken.email,
            resourceAccess: decodedAccessToken.resource_access,
            organizationAccess: decodedAccessToken.organization_access,
            locale: decodedAccessToken.locale,
            // If user's email is in Climatepartner domain and Admin realm is the issuer
            isCpEmployee: decodedAccessToken.email?.endsWith("@climatepartner.com") &&
                decodedAccessToken.iss.endsWith("climatepartner-admin"),
        };
    }
    return null;
}
//# sourceMappingURL=utils.js.map